<template>
  <div>
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("ebayDocs.title") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-app-bar>

    <div class="pa-4">
      <section class="mb-8">
        <h2>{{ $t("ebayDocs.invoice.title") }}</h2>
        <p class="mb-3">{{ $t("ebayDocs.invoice.intro") }}</p>
        <ol class="pl-5 mb-3">
          <li
            v-for="(step, index) in localeList('ebayDocs.invoice.steps')"
            :key="'invoice-step-' + index"
            class="mb-1"
          >
            {{ step }}
          </li>
        </ol>
        <v-alert type="info" variant="outlined" border="start">
          {{ $t("ebayDocs.invoice.note") }}
        </v-alert>
      </section>

      <section class="mb-8">
        <h2>{{ $t("ebayDocs.photos.title") }}</h2>
        <p class="mb-3">{{ $t("ebayDocs.photos.intro") }}</p>
        <p class="mb-3">{{ $t("ebayDocs.photos.typicalCase") }}</p>
        <ol class="pl-5 mb-3">
          <li
            v-for="(step, index) in localeList('ebayDocs.photos.steps')"
            :key="'photos-step-' + index"
            class="mb-1"
          >
            {{ step }}
          </li>
        </ol>
        <v-alert type="warning" variant="outlined" border="start">
          {{ $t("ebayDocs.photos.closing") }}
        </v-alert>
      </section>

      <section class="mb-4">
        <h2>{{ $t("ebayDocs.pricing.title") }}</h2>
        <p class="mb-3">{{ $t("ebayDocs.pricing.intro") }}</p>
        <p class="mb-3">{{ $t("ebayDocs.pricing.howPriceWorks") }}</p>
        <ul class="pl-5 mb-3">
          <li
            v-for="(tip, index) in localeList('ebayDocs.pricing.tips')"
            :key="'pricing-tip-' + index"
            class="mb-1"
          >
            {{ tip }}
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    localeList(key) {
      const value = this.$tm(key);
      if (Array.isArray(value)) return value;
      if (value && typeof value === "object") return Object.values(value);
      return [];
    },
  },
};
</script>

<style scoped>
h2 {
  background-color: #c62828;
  color: white;
  padding: 0.35rem 0.75rem;
  margin-bottom: 0.75rem;
}
</style>
